import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
// import { getAnalytics } from 'firebase/analytics';

const firebaseApp = initializeApp({
  apiKey: "AIzaSyCqICNti32jYlFIZC2EZG_TYLqkAJqA6CE",
  authDomain: "liveaboard-indonesia.firebaseapp.com",
  projectId: "liveaboard-indonesia",
  storageBucket: "liveaboard-indonesia.firebasestorage.app",
  messagingSenderId: "720713144927",
  appId: "1:720713144927:web:bbed31fba234644bb559ea",
  measurementId: "G-XD6FM8CTDS"
});

// getAnalytics(firebaseApp);

export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const fn = getFunctions(firebaseApp);

export default firebaseApp;